import './PreFlights.css';
import './classroom.css';

import { observer, useViewModel } from '@descomplica/microfrontend-react';
import { LoadingSpinner } from '@descomplica/uee-ui-components';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { debounce } from '@/application/utils/generic-functions';

import { ClassroomViewModel } from './classroom.vm';
import CurrentLessonContainer from './components/current-lesson';
import { MobileNavbarContainer } from './components/mobile-navbar';
import SideNavigationContainer from './components/side-navigation';

type Props = {
  isStudyPlan?: boolean;
  isLive?: boolean;
};

const ClassroomScreen = ({ isStudyPlan = false, isLive = false }: Props) => {
  const vm = useViewModel(ClassroomViewModel);

  const { guid, weekOrder, streamingGuid } = useParams();

  useEffect(() => {
    const debouncedHandleResize = debounce(() => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }, 20);

    debouncedHandleResize();

    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);

  useEffect(() => {
    const loadClassroom = async () => {
      console.log('loadClassroom', guid, isStudyPlan, weekOrder, isLive, streamingGuid);
      if (guid) {
        await vm.handleScreenEnter(guid, isStudyPlan, weekOrder, isLive, streamingGuid);
      }
    };

    loadClassroom();
  }, [vm, guid, isStudyPlan, weekOrder, isLive, streamingGuid]);

  if (vm.isLoading)
    return (
      <div className="classroom-loading">
        <LoadingSpinner />
      </div>
    );

  const renderClassroom = () => (
    <div>
      <div className="classroom-page">
        <div className="classroom-content">
          <SideNavigationContainer />
          <CurrentLessonContainer />
        </div>
        <MobileNavbarContainer toggleMenu={vm.toggleMobileSidebar} />
      </div>
    </div>
  );

  return <>{vm.getErrorMessage() || renderClassroom()}</>;
};

export default observer(ClassroomScreen);
